import { makeFilterDocumentSchema, makeStringConditionSchema, matchesStringOp, } from "./filterDocumentPrimitives.js";
// ---------------------------------------------------------------------------
// Field vocabulary (v1) — type + status
// ---------------------------------------------------------------------------
export const RECURRING_TEMPLATE_FILTER_STRING_FIELDS = [
    "template.document_type",
    "template.status",
];
// ---------------------------------------------------------------------------
// Conditions
// ---------------------------------------------------------------------------
/**
 * ONE family in v1, so the condition schema IS the string condition — no
 * union yet. Kept behind the same exported names as the siblings so adding a
 * second family later is a `z.union([...])` here and nothing else changes
 * for the panel.
 *
 * EMPTY-SET SEMANTICS (from the shared primitives): an `in` condition with
 * zero values is REJECTED. "Nothing checked" is spelled as NO CONDITION AT
 * ALL — the panel drops the family — never as a condition that matches nothing.
 */
export const recurringTemplateFilterConditionSchema = makeStringConditionSchema(RECURRING_TEMPLATE_FILTER_STRING_FIELDS);
// ---------------------------------------------------------------------------
// The document
// ---------------------------------------------------------------------------
export const recurringTemplateFilterDocumentSchema = makeFilterDocumentSchema(recurringTemplateFilterConditionSchema);
/** The empty document — "no filters active" (what Clear resets to). */
export const EMPTY_RECURRING_FILTER_DOCUMENT = {
    version: 1,
    match: "all",
    conditions: [],
};
/*
 * One accessor per field FAMILY, an exhaustive switch with NO default case:
 * a new vocabulary entry is a `TS2366: Function lacks ending return
 * statement` until it is handled here, instead of compiling clean and
 * filtering the wrong column.
 */
function stringValue(row, field) {
    switch (field) {
        case "template.document_type":
            return row.document_type;
        case "template.status":
            return row.status;
    }
}
function matchesCondition(row, c) {
    switch (c.op) {
        case "in":
        case "is_empty":
            return matchesStringOp(c.op, stringValue(row, c.field), c.values, c.include_empty);
    }
}
/**
 * Apply a filter document to mapped template rows (AND of all conditions —
 * v1 `match` is 'all' only). An empty document returns the input array
 * unchanged (identity — callers can rely on reference equality to skip
 * re-renders).
 */
export function applyRecurringTemplateFilterDocument(rows, doc) {
    if (doc.conditions.length === 0)
        return rows;
    return rows.filter((row) => doc.conditions.every((c) => matchesCondition(row, c)));
}
/** Count of active conditions — the filter button's badge. */
export function countActiveRecurringTemplateConditions(doc) {
    return doc.conditions.length;
}
//# sourceMappingURL=recurringFilters.js.map